module.exports = __webpack_public_path__ + "static/media/sama4.2b92dd72.wav";